import { LowerCasePipe, SlicePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TransactionSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
} from '@workspace/ng-aura';
import { PriceDisplayPipe, TransactionStatusDisplayPipe } from '@workspace/ng-data-access';
import { TransactionColumnKey } from './abstract-transactions-data-table.component';
import { TransactionsDataTableFilterCoreComponent } from './filter/transactions-data-table-filter.component';

@Component({
  selector: 'core-transactions-data-table',
  templateUrl: './transactions-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    SlicePipe,
    TransactionStatusDisplayPipe,
    PriceDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    TransactionsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
  ],
})
export class TransactionsDataTableCoreComponent extends BaseDataTableCoreComponent<
  TransactionSummaryDto,
  TransactionColumnKey
> {}
